// Built-ins
import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import "moment/locale/en-gb";

// Modules / Functions
import SimpleReactLightbox from "simple-react-lightbox";

// CSS
import "./index.css";
import "semantic-ui-css/semantic.min.css";

// Custom Made Components
import App from "./App";

// Force European day-first dates (dd/mm/yyyy) across the app
moment.locale("en-gb");
document.documentElement.lang = "en-GB";

// Main
ReactDOM.render(
  <SimpleReactLightbox>
    <App />
  </SimpleReactLightbox>,
  document.getElementById("root")
);
